import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Location } from '../../../../core/interfaces/location';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { AdditionalNoteFieldsGasCreate, AdditionalNoteFieldsGasGet, CommodityType, FileType, GasInvoice, InvoiceGasData, InvoiceGasExtractedData, InvoiceGasPDRGet, InvoiceStatus, InvoiceVariableStatus, PriceType, SupplierGet, VisibilityStatus } from '../../../../core/interfaces/invoice-interfaces';
import { CommonValidatorService } from '../../../../core/services/validators/common-validator.service';
import { DateConversionService } from '../../../../core/services/date-conversion.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { LabeledInputComponent } from "../../../../shared/components/labeled-input/labeled-input.component";
import { CustomDateInputComponent } from "../../../../shared/components/custom-date-input/custom-date-input.component";
import { CustomDropdownComponent } from '../../../../shared/components/custom-dropdown/custom-dropdown.component';
import { CommonModule, DecimalPipe } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { InvoiceService } from '../../../../core/api/invoice.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { CustomNumberInputComponent } from '../../../../shared/components/custom-number-input/custom-number-input.component';
import { TextareaInputComponent } from '../../../../shared/components/textarea-input/textarea-input.component';
import { DropDownSectionComponent } from '../../../../shared/components/drop-down-section/drop-down-section.component';
import { InvoiceVariableStatusComponent } from '../../../admin/components/invoice-variable-status/invoice-variable-status.component';
import { EditCancelButtonComponent } from '../../../../shared/components/edit-cancel-button/edit-cancel-button.component';
import { CollapseArrowComponent } from '../../../../shared/components/collapse-arrow/collapse-arrow.component';
import { DeltaValueComponent } from '../../../admin/components/delta-value/delta-value.component';
import { FileDetailsViewComponent } from '../../../admin/components/file-details-view/file-details-view.component';
import { FilesService } from '../../../../core/api/files.service';
import { FileResponse, FullFileDataResponse } from '../../../../core/interfaces/file-upload-interfaces';
import { NavigationShareService } from '../../../../core/services/navigation-share.service';
import { UtilsService } from '../../../../core/services/utils.service';
import { UserDataService } from '../../../../core/services/user-data.service';
import { ToggleButtonComponent } from "../../../../shared/components/toggle-button/toggle-button.component";
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { MandatoryDataMissingComponent } from "../../../admin/components/mandatory-data-missing/mandatory-data-missing.component";
import { InfoTooltipComponent } from "../../../../shared/components/info-tooltip/info-tooltip.component";


@Component({
  selector: 'app-edit-gas-invoice',
  standalone: true,
  imports: [FormsModule, DialogModule, LabeledInputComponent, CustomDateInputComponent, CustomDropdownComponent, TranslocoPipe, CommonModule, CustomNumberInputComponent, TextareaInputComponent, DropDownSectionComponent, InvoiceVariableStatusComponent, EditCancelButtonComponent, CollapseArrowComponent, DeltaValueComponent, FileDetailsViewComponent, ToggleButtonComponent, CustomButtonComponent, MandatoryDataMissingComponent, InfoTooltipComponent],
  providers: [DecimalPipe],
  templateUrl: './edit-gas-invoice.component.html',
  styleUrl: './edit-gas-invoice.component.css'
})
export class EditGasInvoiceComponent implements OnChanges {
  constructor(
    private validator: CommonValidatorService,
    private dateConversion: DateConversionService,
    private transloco: TranslocoService,
    private invoiceService: InvoiceService,
    private apiError: ApiErrorService,
    private filesService: FilesService,
    private decimalPipe: DecimalPipe,
    private navigationShareService: NavigationShareService,
    private utilsService: UtilsService,
    private userData: UserDataService,
    private cd: ChangeDetectorRef
  ) { }

  @Input() invoice: GasInvoice | null = null;
  @Input() listOfLocations: Location[] = [];
  @Input() toast!: ToastComponent;
  @Input() reloadCallbackFunction!: () => void;

  saveClicked: boolean = false;
  successful: boolean = false;

  // Editing Options
  isEditingInvoiceData: boolean = false;

  //Saving
  savingInvoice: boolean = false;

  // Table Collapses
  isInvoiceChargesCollapsed: boolean = false;
  isMaterialCostsCollapsed: boolean = false;
  isTaxesCollapsed: boolean = false;
  isTMSGasCollapsed: boolean = false;
  isVATCollapsed: boolean = false;
  isSupplierCollapsed: boolean = false;
  isVariableTransportationCostsCollapsed: boolean = false;
  isTotalVariableDistributionCostsCollapsed: boolean = false;
  isFixedCostsCollapsed: boolean = false;


  // View all components
  viewAllComponents: boolean = false;

  locationsDropdownOptions: string[] = [];
  selectedLocationDropdown: number | undefined;

  // Dropdowns
  priceTypeDropdownOptions: string[] = [];

  invoiceNumberInput: string = '';
  totalConsumptionInput: string = '';
  invoiceAmountActualInput: string = '';
  invoiceAmountGrossInput: string = '';
  forPeriodDate: Date | undefined;
  totalDiscountInput: string = '';
  vatRateInput: string = '';
  vatAmountInput: string = '';
  nontaxableAmountInput: string = '';

  adminNotesInput: string = '';

  invoiceNumberInputError: string | null = null;
  totalConsumptionInputError: string | null = null;
  invoiceAmountActualInputError: string | null = null;
  invoiceAmountGrossInputError: string | null = null;
  forPeriodInputError: string | null = null;
  totalDiscountInputError: string | null = null;
  vatRateInputError: string | null = null;
  vatAmountInputError: string | null = null;
  nontaxableAmountInputError: string | null = null;
  locationDropdownError: string | null = null;
  gasMarketPriceInputWarnings: (string | null)[] = [];
  monthGasConsumptionInputWarnings: (string | null)[] = [];
  materialCostFactorInputWarnings: (string | null)[] = [];
  fixedGasConsumptionInputWarnings: (string | null)[] = [];
  variableTransportationFeeInputWarnings: (string | null)[] = [];
  taxRateGasScale1InputWarnings: (string | null)[] = [];
  taxRateGasScale2InputWarnings: (string | null)[] = [];
  taxRateGasScale3InputWarnings: (string | null)[] = [];
  taxRateGasScale4InputWarnings: (string | null)[] = [];
  varDistributionFeeTier1InputWarnings: (string | null)[] = [];
  varDistributionFeeTier2InputWarnings: (string | null)[] = [];
  varDistributionFeeTier3InputWarnings: (string | null)[] = [];
  varDistributionFeeTier4InputWarnings: (string | null)[] = [];
  varDistributionFeeTier5InputWarnings: (string | null)[] = [];
  varDistributionFeeTier6InputWarnings: (string | null)[] = [];
  varDistributionFeeTier7InputWarnings: (string | null)[] = [];
  varDistributionFeeTier8InputWarnings: (string | null)[] = [];
  fixedDistributionCostsGasCalcInputWarnings: (string | null)[] = [];
  materialCostsGasVariableActualInputWarnings: (string | null)[] = [];
  materialCostsGasFixedActualInputWarnings: (string | null)[] = [];
  totalGasTaxesActualInputWarnings: (string | null)[] = [];
  totalConsumptionInputWarning: string | null = null;
  invoiceAmountActualInputWarning: string | null = null;
  priceTypeDropdownWarning: (string | null)[] = [];
  variableGasConsumptionInputWarnings: (string | null)[] = [];
  hcvInputWarnings: (string | null)[] = [];
  spreadInputWarnings: (string | null)[] = [];
  pdrIdInputWarnings: (string | null)[] = [];
  gasMeterClassInputWarnings: (string | null)[] = [];
  gasIntensityClassInputWarnings: (string | null)[] = [];
  remiTypeInputWarnings: (string | null)[] = [];
  taxRegionInputWarnings: (string | null)[] = [];
  areaInputWarnings: (string | null)[] = [];
  exerciseTaxTypeGasInputWarnings: (string | null)[] = [];
  taxTypeGasInputWarnings: (string | null)[] = [];
  tmsGasChargesActualInputWarnings: (string | null)[] = [];

  adminNotesInputError: string | null = null;

  editedPDRs: {
    pdr_id?: string;
    spread?: string;
    gas_market_price?: string;
    price_gas_var_actual?: string;
    price_gas_fix?: string;
    hcv_gas?: string;
    taxrate_gas_scale1?: string;
    taxrate_gas_scale2?: string;
    taxrate_gas_scale3?: string;
    taxrate_gas_scale4?: string;

    month_gas_consumption?: string;
    variable_gas_consumption?: string;
    fixed_gas_consumption?: string;
    daily_gas_capacity?: string;

    price_type_gas?: string;
    selectedPriceTypeDropdown?: number | undefined;

    gas_market_index?: string;
    gas_intensity_class?: string;
    gas_meter_class?: string;
    REMI_type_gas?: string;
    area_gas?: string;
    tax_region?: string;

    daily_capacity_factor_gas?: string;
    fixed_charge_gas_actual?: string;
    material_cost_factor?: string;
    material_costs_gas_variable_actual?: string;
    material_costs_gas_fixed_actual?: string;
    fixed_distribution_costs_gas_actual?: string;
    fixed_distribution_costs_gas_calc?: string;
    variable_transportation_fee?: string;
    var_transportation_costs_actual?: string;
    total_var_distribution_costs_actual?: string;

    var_distribution_fee_tier1?: string;
    var_distribution_fee_tier2?: string;
    var_distribution_fee_tier3?: string;
    var_distribution_fee_tier4?: string;
    var_distribution_fee_tier5?: string;
    var_distribution_fee_tier6?: string;
    var_distribution_fee_tier7?: string;
    var_distribution_fee_tier8?: string;

    vat_rate?: string;
    vat_amount_actual?: string;

    tms_gas_charges_actual?: string;

    total_gas_taxes_actual?: string;
    additional_gas_charges?: string;
    total_gas_discount_amount?: string;

    fixed_quota?: string;

    exercise_tax_type_gas?: string;
    tax_type_gas?: string;
    supplierData: {
      name?: string;
      vat_id?: string;
      contact_name?: string;
      contact_number?: string;
      email?: string;
      start_of_supply?: Date;
      end_of_supply?: Date;
    };
    additionalNoteFields: {
      invoice_charges?: string;
    };
  }[] = [];

  // File Summary
  loadingFileSummary: boolean = true;
  fileDetailsResponse: FullFileDataResponse | null = null;

  // Type helpers
  PriceType = PriceType;
  InvoiceVariableStatus = InvoiceVariableStatus;

  // DropDown Sections
  @ViewChild('invoiceDataDropdown') invoiceDataDropdown?: DropDownSectionComponent;
  @ViewChild('invoiceDataDropdown', { read: ElementRef }) invoiceDataDropdownEl?: ElementRef;

  @ViewChildren('pdrSection') pdrSectionsDropdown?: QueryList<DropDownSectionComponent>;

  // Mandatory data
  mandatoryDataMissing: boolean = false;

  // Additiona fields expresion changes
  exprByField: Record<string, string> = {};

  // Track open pdrs
  private openedPdrSectionIndexes = new Set<number>();

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['invoice'] || changes['listOfLocations']) && this.invoice) {
      this.updateEditData(this.invoice, this.listOfLocations);
    }
  }

  updateEditData(invoice: GasInvoice, listOfLocations: Location[]): void {
    this.successful = false;
    this.saveClicked = false;
    this.invoice = invoice;
    this.listOfLocations = listOfLocations;
    this.populateStaticDropdowns();
    this.populateInputsFromInvoice(invoice);
    this.populateLocationsDropdown();
    this.validateRequiredFields();

    this.cd.detectChanges();

    setTimeout(() => {
      this.restoreOpenedPdrSections();
    });
  }

  resetInvoiceData() {
    if (this.invoice) {
      this.updateEditData(this.invoice, this.listOfLocations);
    }
  }

  populateStaticDropdowns() {
    this.priceTypeDropdownOptions = [];
    this.priceTypeDropdownOptions = Object.values(PriceType)
  }

  populateLocationsDropdown(): void {
    this.locationsDropdownOptions = [];

    this.listOfLocations.forEach((location, index) => {
      const label = `${location.street ?? ''} ${location.number ?? ''}, ${location.postal_code ?? ''} ${location.city ?? ''}`;
      this.locationsDropdownOptions.push(label);

      if (location.id === this.invoice?.location_id) {
        this.selectedLocationDropdown = index;
      }
    });
  }

  populateInputsFromInvoice(invoice: GasInvoice): void {
    this.invoiceNumberInput = invoice.invoice_number ?? '';
    this.totalConsumptionInput = invoice.total_consumption?.toString() ?? '';
    this.invoiceAmountActualInput = invoice.invoice_amount_net_actual?.toString() ?? '';
    this.invoiceAmountGrossInput = invoice.invoice_amount_gross_actual?.toString() ?? '';
    this.forPeriodDate = invoice.for_period ? new Date(invoice.for_period) : undefined;
    this.totalDiscountInput = invoice.total_discount_amount?.toString() ?? '';
    this.vatRateInput = invoice.vat_rate?.toString() ?? '';
    this.vatAmountInput = invoice.vat_amount_actual?.toString() ?? '';
    this.nontaxableAmountInput = invoice.nontaxable_amount?.toString() ?? '';
    this.adminNotesInput = invoice.admin_notes ?? '';

    this.editedPDRs = invoice.pdrs.map(p => ({
      pdr_id: p.pdr_id?.toString() ?? '',
      spread: p.spread?.toString() ?? '',
      gas_market_price: p.gas_market_price?.toString() ?? '',
      price_gas_var_actual: p.price_gas_var_actual?.toString() ?? '',
      price_gas_fix: p.price_gas_fix?.toString() ?? '',
      hcv_gas: p.hcv_gas?.toString() ?? '',
      taxrate_gas_scale1: p.taxrate_gas_scale1?.toString() ?? '',
      taxrate_gas_scale2: p.taxrate_gas_scale2?.toString() ?? '',
      taxrate_gas_scale3: p.taxrate_gas_scale3?.toString() ?? '',
      taxrate_gas_scale4: p.taxrate_gas_scale4?.toString() ?? '',

      month_gas_consumption: p.month_gas_consumption?.toString() ?? '',
      variable_gas_consumption: p.variable_gas_consumption?.toString() ?? '',
      fixed_gas_consumption: p.fixed_gas_consumption?.toString() ?? '',
      daily_gas_capacity: p.daily_gas_capacity?.toString() ?? '',

      price_type_gas: p.price_type_gas ?? '',
      gas_market_index: p.gas_market_index ?? '',
      gas_intensity_class: p.gas_intensity_class ?? '',
      gas_meter_class: p.gas_meter_class ?? '',
      REMI_type_gas: p.REMI_type_gas ?? '',
      area_gas: p.area_gas ?? '',
      tax_region: p.tax_region ?? '',

      daily_capacity_factor_gas: p.daily_capacity_factor_gas?.toString() ?? '',
      fixed_charge_gas_actual: p.fixed_charge_gas_actual?.toString() ?? '',
      material_cost_factor: p.material_cost_factor?.toString() ?? '',
      material_costs_gas_variable_actual: p.material_costs_gas_variable_actual?.toString() ?? '',
      material_costs_gas_fixed_actual: p.material_costs_gas_fixed_actual?.toString() ?? '',
      fixed_distribution_costs_gas_actual: p.fixed_distribution_costs_gas_actual?.toString() ?? '',
      fixed_distribution_costs_gas_calc: p.fixed_distribution_costs_gas_calc?.toString() ?? '',
      variable_transportation_fee: p.variable_transportation_fee?.toString() ?? '',
      var_transportation_costs_actual: p.var_transportation_costs_actual?.toString() ?? '',
      total_var_distribution_costs_actual: p.total_var_distribution_costs_actual?.toString() ?? '',

      var_distribution_fee_tier1: p.var_distribution_fee_tier1?.toString() ?? '',
      var_distribution_fee_tier2: p.var_distribution_fee_tier2?.toString() ?? '',
      var_distribution_fee_tier3: p.var_distribution_fee_tier3?.toString() ?? '',
      var_distribution_fee_tier4: p.var_distribution_fee_tier4?.toString() ?? '',
      var_distribution_fee_tier5: p.var_distribution_fee_tier5?.toString() ?? '',
      var_distribution_fee_tier6: p.var_distribution_fee_tier6?.toString() ?? '',
      var_distribution_fee_tier7: p.var_distribution_fee_tier7?.toString() ?? '',
      var_distribution_fee_tier8: p.var_distribution_fee_tier8?.toString() ?? '',

      tms_gas_charges_actual: p.tms_gas_charges_actual?.toString() ?? '',

      total_gas_taxes_actual: p.total_gas_taxes_actual?.toString() ?? '',
      additional_gas_charges: p.additional_gas_charges?.toString() ?? '',
      total_gas_discount_amount: p.total_gas_discount_amount?.toString() ?? '',

      vat_rate: p.vat_rate?.toString() ?? '',
      vat_amount_actual: p.vat_amount_actual?.toString() ?? '',

      selectedPriceTypeDropdown: (i => i !== -1 ? i : undefined)(this.priceTypeDropdownOptions.findIndex(option => option === p.price_type_gas)),

      exercise_tax_type_gas: p.exercise_tax_type_gas?.toString() ?? '',
      tax_type_gas: p.tax_type_gas?.toString() ?? '',

      fixed_quota: p.fixed_quota?.toString() ?? '',

      supplierData: {
        name: p.supplier?.name ?? '',
        vat_id: p.supplier?.vat_id ?? '',
        contact_name: p.supplier?.contact_name ?? '',
        contact_number: p.supplier?.contact_number ?? '',
        email: p.supplier?.email ?? '',
        start_of_supply: p.supplier?.start_of_supply ? new Date(p.supplier.start_of_supply) : undefined,
        end_of_supply: p.supplier?.end_of_supply ? new Date(p.supplier.end_of_supply) : undefined,
      },
      additionalNoteFields: {
        invoice_charges: p.additional_note_fields?.invoice_charges?.toString() || '',
      },
    }));
  }

  getAdditionalNoteFieldsFromInputs(index: number, additionalNote: AdditionalNoteFieldsGasGet | null): AdditionalNoteFieldsGasCreate {
    const additionalNoteFields: AdditionalNoteFieldsGasCreate = {
      invoice_charges: parseFloat(this.editedPDRs[index].additionalNoteFields.invoice_charges || '') || (additionalNote?.invoice_charges ?? null)
    };
    return additionalNoteFields;
  }

  getGasInvoiceDataFromInputs(): InvoiceGasData {
    const selectedLocation = this.navigationShareService.getState("invoiceReviewLocation");

    const invoiceData: InvoiceGasData = {
      id: this.invoice?.id ?? '',
      processed_at: new Date().toISOString(),
      type: CommodityType.gas,
      file_type: FileType.invoice,
      data: {
        location: {
          street: selectedLocation.street ?? null,
          number: selectedLocation.number ?? null,
          postal_code: selectedLocation.postal_code ?? null,
          city: selectedLocation.city ?? null,
          province: selectedLocation.province ?? null,
          latitude: selectedLocation.latitude ?? null,
          longitude: selectedLocation.longitude ?? null
        },
        invoice_data: {
          for_period: this.invoice!.for_period,
          invoice_number: this.invoiceNumberInput,
          total_consumption: parseFloat(this.totalConsumptionInput),
          invoice_amount_net_actual: parseFloat(this.invoiceAmountActualInput),
          invoice_amount_gross_actual: parseFloat(this.invoiceAmountGrossInput),
          consumption_class: null,
          additional_charges: null,
          total_discount_amount: parseFloat(this.totalDiscountInput) ?? null,
          vat_rate: parseFloat(this.vatRateInput) ?? null,
          vat_amount_actual: parseFloat(this.vatAmountInput) ?? null,
          nontaxable_amount: parseFloat(this.nontaxableAmountInput) ?? null,
          admin_notes: this.adminNotesInput || null
        },
        pdr_data: this.editedPDRs.map((pdr, i) => {
          const original = this.invoice?.pdrs[i];
          const selectedPriceType = this.priceTypeDropdownOptions[pdr.selectedPriceTypeDropdown!].toUpperCase();

          return {
            total_taxes: this.invoice?.total_taxes ?? null,

            spread: parseFloat(pdr.spread ?? '') ?? null,
            fixed_quota: parseFloat(pdr.fixed_quota ?? '') ?? null,
            forecast_index_value: original?.forecast_index_value,

            month_gas_consumption: parseFloat(pdr.month_gas_consumption ?? '') ?? null,
            variable_gas_consumption: parseFloat(pdr.variable_gas_consumption ?? '') ?? null,
            fixed_gas_consumption: parseFloat(pdr.fixed_gas_consumption ?? '') ?? null,
            gas_perc_with_var_price: original?.gas_perc_with_var_price,
            daily_gas_capacity: parseFloat(pdr.daily_gas_capacity ?? '') ?? null,

            price_type_gas: selectedPriceType ?? null,

            gas_market_index: pdr.gas_market_index ?? null,
            gas_market_price: parseFloat(pdr.gas_market_price ?? '') ?? null,
            price_gas_var_actual: parseFloat(pdr.price_gas_var_actual ?? '') ?? null,
            price_gas_fix: parseFloat(pdr.price_gas_fix ?? '') ?? null,
            hcv_gas: parseFloat(pdr.hcv_gas ?? '') ?? null,

            gas_intensity_class: pdr.gas_intensity_class ?? null,
            gas_meter_class: pdr.gas_meter_class ?? null,
            REMI_type_gas: pdr.REMI_type_gas ?? null,
            area_gas: pdr.area_gas ?? null,
            tax_region: pdr.tax_region ?? null,

            daily_capacity_factor_gas: parseFloat(pdr.daily_capacity_factor_gas ?? '') ?? null,
            fixed_charge_gas_actual: parseFloat(pdr.fixed_charge_gas_actual ?? '') ?? null,

            material_cost_factor: parseFloat(pdr.material_cost_factor ?? '') ?? null,
            material_costs_gas_variable_actual: parseFloat(pdr.material_costs_gas_variable_actual ?? '') ?? null,
            material_costs_gas_fixed_actual: parseFloat(pdr.material_costs_gas_fixed_actual ?? '') ?? null,

            fixed_distribution_costs_gas_calc: parseFloat(pdr.fixed_distribution_costs_gas_calc ?? '') ?? null,
            fixed_distribution_costs_gas_actual: parseFloat(pdr.fixed_distribution_costs_gas_actual ?? '') ?? null,
            variable_transportation_fee: parseFloat(pdr.variable_transportation_fee ?? '') ?? null,
            var_transportation_costs_actual: parseFloat(pdr.var_transportation_costs_actual ?? '') ?? null,

            total_var_distribution_costs_actual: parseFloat(pdr.total_var_distribution_costs_actual ?? '') ?? null,

            tms_gas_charges_actual: parseFloat(pdr.tms_gas_charges_actual ?? '') ?? null,

            exercise_tax_type_gas: pdr.exercise_tax_type_gas ?? null,
            tax_type_gas: pdr.tax_type_gas ?? null,

            taxrate_gas_scale1: parseFloat(pdr.taxrate_gas_scale1 ?? '') ?? null,
            taxrate_gas_scale2: parseFloat(pdr.taxrate_gas_scale2 ?? '') ?? null,
            taxrate_gas_scale3: parseFloat(pdr.taxrate_gas_scale3 ?? '') ?? null,
            taxrate_gas_scale4: parseFloat(pdr.taxrate_gas_scale4 ?? '') ?? null,

            total_gas_taxes_actual: parseFloat(pdr.total_gas_taxes_actual ?? '') ?? null,
            additional_gas_charges: parseFloat(pdr.additional_gas_charges ?? '') ?? null,
            total_gas_discount_amount: parseFloat(pdr.total_gas_discount_amount ?? '') ?? null,

            var_distribution_fee_tier1: parseFloat(pdr.var_distribution_fee_tier1 ?? '') ?? null,
            var_distribution_fee_tier2: parseFloat(pdr.var_distribution_fee_tier2 ?? '') ?? null,
            var_distribution_fee_tier3: parseFloat(pdr.var_distribution_fee_tier3 ?? '') ?? null,
            var_distribution_fee_tier4: parseFloat(pdr.var_distribution_fee_tier4 ?? '') ?? null,
            var_distribution_fee_tier5: parseFloat(pdr.var_distribution_fee_tier5 ?? '') ?? null,
            var_distribution_fee_tier6: parseFloat(pdr.var_distribution_fee_tier6 ?? '') ?? null,
            var_distribution_fee_tier7: parseFloat(pdr.var_distribution_fee_tier7 ?? '') ?? null,
            var_distribution_fee_tier8: parseFloat(pdr.var_distribution_fee_tier8 ?? '') ?? null,

            pdr_id: pdr?.pdr_id ?? null,

            vat_rate: parseFloat(pdr.vat_rate ?? '') ?? null,
            vat_amount_actual: parseFloat(pdr.vat_amount_actual ?? '') ?? null,

            supplier: {
              name: pdr.supplierData.name ?? null,
              vat_id: pdr.supplierData.vat_id ?? null,
              contact_number: pdr.supplierData.contact_number ?? null,
              email: pdr.supplierData.email ?? null,
              contact_name: pdr.supplierData.contact_name ?? null,
              start_of_supply: pdr.supplierData.start_of_supply ?? null,
              end_of_supply: pdr.supplierData.end_of_supply ?? null
            },

            location: {
              street: selectedLocation.street ?? null,
              number: selectedLocation.number ?? null,
              postal_code: selectedLocation.postal_code ?? null,
              city: selectedLocation.city ?? null,
              province: selectedLocation.province ?? null
            }
          } as InvoiceGasExtractedData;
        }),
        historical_data: []
      }
    };

    return invoiceData;
  }

  getGasInvoiceFromInputs(): GasInvoice {
    const selectedLocation = this.navigationShareService.getState('invoiceReviewLocation');
    const base = this.invoice as (GasInvoice | null);

    return {
      // BaseInvoiceGet
      id: base?.id ?? '',
      created_at: base?.created_at ?? new Date().toISOString(),
      file: base?.file as FileResponse,
      company_id: base?.company_id ?? '',
      location_id: base?.location_id ?? null,
      status: base?.status ?? InvoiceStatus.DONE,
      for_period: base?.for_period ?? this.invoice?.for_period ?? null,
      invoice_number: this.invoiceNumberInput ?? base?.invoice_number ?? null,
      supplier_name: base?.supplier_name ?? null,

      total_consumption: this.utilsService.numberOrNull(this.totalConsumptionInput),
      invoice_amount_net_actual: this.utilsService.numberOrNull(this.invoiceAmountActualInput),
      invoice_amount_gross_actual: this.utilsService.numberOrNull(this.invoiceAmountGrossInput),

      total_taxes: base?.total_taxes ?? null,
      tms_charges: base?.tms_charges ?? null,

      is_consumption_ok: base?.is_consumption_ok ?? false,
      is_taxes_ok: base?.is_taxes_ok ?? false,
      is_invoice_amount_ok: base?.is_invoice_amount_ok ?? false,
      is_vat_amount_ok: base?.is_vat_amount_ok ?? false,
      is_invoice_amount_gross_ok: base?.is_invoice_amount_gross_ok ?? false,

      total_discount_amount: this.utilsService.numberOrNull(this.totalDiscountInput) ?? base?.total_discount_amount ?? null,
      vat_rate: this.utilsService.numberOrNull(this.vatRateInput) ?? base?.vat_rate ?? null,
      vat_amount_actual: this.utilsService.numberOrNull(this.vatAmountInput) ?? base?.vat_amount_actual ?? null,
      nontaxable_amount: this.utilsService.numberOrNull(this.nontaxableAmountInput) ?? base?.nontaxable_amount ?? null,

      consumption_class: base?.consumption_class ?? null,

      visibility_status: base?.visibility_status ?? VisibilityStatus.UNDER_ADMIN_REVIEW,
      admin_notes: (this.adminNotesInput ?? base?.admin_notes) ?? null,

      admin_approved: base?.admin_approved ?? false,
      review_requested: base?.review_requested ?? false,

      expected_vat_rate: base?.expected_vat_rate ?? null,
      additional_charges: base?.additional_charges ?? null,

      // PDRs - InvoiceGasPDRGet
      pdrs: (this.editedPDRs ?? []).map((pdr: any, i: number) => {
        const orig = base?.pdrs?.[i];

        const selectedPriceType =
          pdr?.selectedPriceTypeDropdown != null
            ? this.priceTypeDropdownOptions[pdr.selectedPriceTypeDropdown]?.toUpperCase() ?? null
            : orig?.price_type_gas ?? null;

        const monthGasConsumption = this.utilsService.numberOrNull(pdr.month_gas_consumption);
        return {
          id: orig?.id ?? null,

          spread: this.utilsService.numberOrNull(pdr.spread),
          fixed_quota: this.utilsService.numberOrNull(pdr.fixed_quota),
          forecast_index_value: orig?.forecast_index_value ?? null,

          pdr_id: pdr?.pdr_id ?? null,
          pdr_region: pdr?.pdr_region ?? orig?.pdr_region ?? null,
          pdr_province: pdr?.pdr_province ?? orig?.pdr_province ?? null,
          pdr_community: pdr?.pdr_community ?? orig?.pdr_community ?? null,
          tax_region: pdr?.tax_region || orig?.tax_region || null,
          area_gas: pdr?.area_gas ?? orig?.area_gas ?? null,
          REMI_type_gas: pdr?.REMI_type_gas ?? orig?.REMI_type_gas ?? null,
          gas_meter_class: pdr?.gas_meter_class ?? orig?.gas_meter_class ?? null,
          gas_intensity_class: pdr?.gas_intensity_class ?? orig?.gas_intensity_class ?? null,

          month_gas_consumption: (monthGasConsumption ?? 0) as number,

          gas_perc_with_var_price: this.utilsService.numberOrNull(pdr.gas_perc_with_var_price) ?? orig?.gas_perc_with_var_price ?? null,
          daily_gas_capacity: this.utilsService.numberOrNull(pdr.daily_gas_capacity),

          price_type_gas: selectedPriceType,

          variable_gas_consumption: this.utilsService.numberOrNull(pdr.variable_gas_consumption),
          fixed_gas_consumption: this.utilsService.numberOrNull(pdr.fixed_gas_consumption),

          gas_market_index: pdr?.gas_market_index ?? orig?.gas_market_index ?? null,
          gas_market_price: this.utilsService.numberOrNull(pdr.gas_market_price),
          price_gas_var_actual: this.utilsService.numberOrNull(pdr.price_gas_var_actual),
          price_gas_fix: this.utilsService.numberOrNull(pdr.price_gas_fix),
          hcv_gas: this.utilsService.numberOrNull(pdr.hcv_gas),

          daily_capacity_factor_gas: this.utilsService.numberOrNull(pdr.daily_capacity_factor_gas),
          fixed_charge_gas_actual: this.utilsService.numberOrNull(pdr.fixed_charge_gas_actual),

          material_cost_factor: this.utilsService.numberOrNull(pdr.material_cost_factor),
          material_costs_gas_variable_actual: this.utilsService.numberOrNull(pdr.material_costs_gas_variable_actual),
          material_costs_gas_fixed_actual: this.utilsService.numberOrNull(pdr.material_costs_gas_fixed_actual),

          fixed_distribution_costs_gas_calc: this.utilsService.numberOrNull(pdr.fixed_distribution_costs_gas_calc),
          fixed_distribution_costs_gas_actual: this.utilsService.numberOrNull(pdr.fixed_distribution_costs_gas_actual),
          variable_transportation_fee: this.utilsService.numberOrNull(pdr.variable_transportation_fee),
          var_transportation_costs_actual: this.utilsService.numberOrNull(pdr.var_transportation_costs_actual),

          var_distribution_fee_tier1: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier1),
          var_distribution_fee_tier2: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier2),
          var_distribution_fee_tier3: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier3),
          var_distribution_fee_tier4: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier4),
          var_distribution_fee_tier5: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier5),
          var_distribution_fee_tier6: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier6),
          var_distribution_fee_tier7: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier7),
          var_distribution_fee_tier8: this.utilsService.numberOrNull(pdr.var_distribution_fee_tier8),
          total_var_distribution_costs_actual: this.utilsService.numberOrNull(pdr.total_var_distribution_costs_actual),

          tms_gas_charges_actual: this.utilsService.numberOrNull(pdr.tms_gas_charges_actual),

          exercise_tax_type_gas: pdr.exercise_tax_type_gas ?? null,
          tax_type_gas: pdr.tax_type_gas ?? null,

          taxrate_gas_scale1: this.utilsService.numberOrNull(pdr.taxrate_gas_scale1),
          taxrate_gas_scale2: this.utilsService.numberOrNull(pdr.taxrate_gas_scale2),
          taxrate_gas_scale3: this.utilsService.numberOrNull(pdr.taxrate_gas_scale3),
          taxrate_gas_scale4: this.utilsService.numberOrNull(pdr.taxrate_gas_scale4),

          total_gas_taxes_actual: this.utilsService.numberOrNull(pdr.total_gas_taxes_actual),
          additional_gas_charges: this.utilsService.numberOrNull(pdr.additional_gas_charges),
          total_gas_discount_amount: this.utilsService.numberOrNull(pdr.total_gas_discount_amount),

          cost_data: orig?.cost_data ?? null,

          is_unit_prices_ok: orig?.is_unit_prices_ok ?? false,
          is_material_costs_ok: orig?.is_material_costs_ok ?? false,
          is_distribution_costs_ok: orig?.is_distribution_costs_ok ?? false,
          is_transportation_costs_ok: orig?.is_transportation_costs_ok ?? false,

          vat_rate: this.utilsService.numberOrNull(pdr.vat_rate),
          vat_amount_actual: this.utilsService.numberOrNull(pdr.vat_amount_actual),

          calc_data: orig?.calc_data ?? null,

          supplier: {
            id: orig?.supplier?.id ?? null,
            name: pdr?.supplierData?.name ?? orig?.supplier?.name ?? null,
            vat_id: pdr?.supplierData?.vat_id ?? orig?.supplier?.vat_id ?? null,
            contact_number: pdr?.supplierData?.contact_number ?? orig?.supplier?.contact_number ?? null,
            contact_name: pdr?.supplierData?.contact_name ?? orig?.supplier?.contact_name ?? null,
            email: pdr?.supplierData?.email ?? orig?.supplier?.email ?? null,
            start_of_supply: pdr?.supplierData?.start_of_supply
              ? this.dateConversion.dateToIso(pdr?.supplierData?.start_of_supply)
              : orig?.supplier?.start_of_supply ?? null,
            end_of_supply: pdr?.supplierData?.end_of_supply
              ? this.dateConversion.dateToIso(pdr?.supplierData?.end_of_supply)
              : orig?.supplier?.end_of_supply ?? null,
          } as SupplierGet,
          additional_note_fields: this.getAdditionalNoteFieldsFromInputs(i, pdr.additional_note_fields)
        } as InvoiceGasPDRGet;
      }),
    };
  }
  private isFieldEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  onFieldChange({ value, pdrIndex, targetArray, fieldName }: { value: number; pdrIndex?: number; targetArray?: (string | null)[]; fieldName?: string; }): void {
    if (pdrIndex === undefined) {
      switch (fieldName) {
        case 'totalConsumption':
          this.totalConsumptionInputWarning = value !== 0 ? null : this.validator.validateRecommendedField('');
          break;
        case 'invoiceAmountActual':
          this.invoiceAmountActualInputWarning = value !== 0 ? null : this.validator.validateRecommendedField('');
          break;
      }
      return;
    }

    if (pdrIndex !== undefined) {
      let warning;

      if (fieldName && (fieldName === 'variable_gas_consumption' || fieldName === 'spread' || fieldName === 'gas_market_price')) {
        if (this.isFieldEmpty(this.editedPDRs[pdrIndex].material_costs_gas_variable_actual)) {
          warning = value !== 0 ? null : this.validator.validateRecommendedField('');
        } else {
          warning = null;
        }
      }
      else if (fieldName && fieldName === 'material_costs_gas_variable_actual') {
        warning = value !== 0 ? null : this.validator.validateRecommendedField('');
        if (warning) {
          const variable_gas_consumption_length = this.editedPDRs[pdrIndex].variable_gas_consumption?.length ?? 0;
          const spread_length = this.editedPDRs[pdrIndex].spread?.length ?? 0;
          const gas_market_price_length = this.editedPDRs[pdrIndex].gas_market_price?.length ?? 0;
          this.variableGasConsumptionInputWarnings[pdrIndex] = variable_gas_consumption_length !== 0 ? null : this.validator.validateRecommendedField('');
          this.spreadInputWarnings[pdrIndex] = spread_length !== 0 ? null : this.validator.validateRecommendedField('');
          this.gasMarketPriceInputWarnings[pdrIndex] = gas_market_price_length !== 0 ? null : this.validator.validateRecommendedField('');
        } else {
          this.variableGasConsumptionInputWarnings[pdrIndex] = null;
          this.spreadInputWarnings[pdrIndex] = null;
          this.gasMarketPriceInputWarnings[pdrIndex] = null;
        }

      }
      else {
        warning = value !== 0 ? null : this.validator.validateRecommendedField('');
      }

      if (targetArray) {
        targetArray[pdrIndex] = warning ?? null;
      }
    }
  }

  onPriceTypeChange(pdrIndex: number): void {
    this.validateRequiredFields();
  }

  validateRequiredFields(): void {
    //Validate Invoice fields
    this.invoiceNumberInputError = this.validator.validateLength(this.invoiceNumberInput, 1, 100);
    this.totalConsumptionInputWarning = this.validator.validateRecommendedField(this.totalConsumptionInput);
    this.invoiceAmountActualInputWarning = this.validator.validateRecommendedField(this.invoiceAmountActualInput);
    if (this.selectedLocationDropdown === undefined) {
      this.locationDropdownError = this.transloco.translate('shared.validators.common.required');
    } else {
      this.locationDropdownError = null;
    }

    if (this.forPeriodDate) {
      const formatted = this.dateConversion.isoToFormattedDate(this.forPeriodDate.toISOString());
      this.forPeriodInputError = this.validator.validateDate(formatted);
    } else {
      this.forPeriodInputError = this.transloco.translate('shared.validators.common.required');
    }

    //Validate PDR fields
    this.gasMarketPriceInputWarnings = this.editedPDRs.map(pdr => {
      if (this.isFieldEmpty(pdr.material_costs_gas_variable_actual)) {
        return this.validator.validateRecommendedField(pdr.gas_market_price || '')
      }
      return null
    });

    this.monthGasConsumptionInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.month_gas_consumption || '')
    );

    this.materialCostFactorInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.material_cost_factor || '')
    );

    this.fixedGasConsumptionInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.fixed_gas_consumption || '')
    );

    this.variableTransportationFeeInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.variable_transportation_fee || '')
    );

    this.taxRateGasScale1InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.taxrate_gas_scale1 || '')
    );

    this.taxRateGasScale2InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.taxrate_gas_scale2 || '')
    );

    this.taxRateGasScale3InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.taxrate_gas_scale3 || '')
    );

    this.taxRateGasScale4InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.taxrate_gas_scale4 || '')
    );

    this.varDistributionFeeTier1InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier1 || '')
    );

    this.varDistributionFeeTier2InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier2 || '')
    );

    this.varDistributionFeeTier3InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier3 || '')
    );

    this.varDistributionFeeTier4InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier4 || '')
    );

    this.varDistributionFeeTier5InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier5 || '')
    );

    this.varDistributionFeeTier6InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier6 || '')
    );

    this.varDistributionFeeTier7InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier7 || '')
    );

    this.varDistributionFeeTier8InputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.var_distribution_fee_tier8 || '')
    );

    this.fixedDistributionCostsGasCalcInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.fixed_distribution_costs_gas_calc || '')
    );

    this.materialCostsGasVariableActualInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.material_costs_gas_variable_actual || '')
    );

    this.materialCostsGasFixedActualInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.material_costs_gas_fixed_actual || '')
    );

    this.totalGasTaxesActualInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.total_gas_taxes_actual || '')
    );

    this.tmsGasChargesActualInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.tms_gas_charges_actual || '')
    );

    this.priceTypeDropdownWarning = this.editedPDRs.map(pdr => {
      if (pdr.selectedPriceTypeDropdown === undefined) {
        return this.transloco.translate('shared.validators.common.mandatory_field');
      }
      return null
    });

    this.variableGasConsumptionInputWarnings = this.editedPDRs.map(pdr => {
      if (this.isFieldEmpty(pdr.material_costs_gas_variable_actual)) {
        return this.validator.validateRecommendedField(pdr.variable_gas_consumption || '')
      }
      return null
    });

    this.hcvInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.hcv_gas || '')
    );

    this.spreadInputWarnings = this.editedPDRs.map(pdr => {
      if (this.isFieldEmpty(pdr.material_costs_gas_variable_actual)) {
        return this.validator.validateRecommendedField(pdr.spread || '')
      }
      return null
    });

    this.pdrIdInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.pdr_id || '')
    );

    this.gasIntensityClassInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.gas_intensity_class || '')
    );

    this.gasMeterClassInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.gas_meter_class || '')
    );

    this.remiTypeInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.REMI_type_gas || '')
    );

    this.areaInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.area_gas || '')
    );

    this.taxRegionInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.tax_region || '')
    );

    this.exerciseTaxTypeGasInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.tax_region || '')
    );

    this.taxTypeGasInputWarnings = this.editedPDRs.map(pdr =>
      this.validator.validateRecommendedField(pdr.tax_type_gas || '')
    );

  }

  validateInputs(): boolean {
    if (this.navigationShareService.getState("invoiceReviewLocation") === undefined) {
      this.toast.showToast("shared.error", "shared.toast.select_location", "error", 4000, true);
      return false;
    }

    for (const pdr of this.editedPDRs) {
      if (pdr.selectedPriceTypeDropdown === undefined) {
        this.toast.showToast('shared.error', 'invoice.placeholders.price_type', 'error', 4000, true);
        return false;
      }
    }

    this.invoiceNumberInputError = this.validator.validateLength(this.invoiceNumberInput, 1, 100);
    this.totalConsumptionInputError = this.validator.validateNumber(this.totalConsumptionInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.invoiceAmountActualInputError = this.validator.validateNumber(this.invoiceAmountActualInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.invoiceAmountGrossInputError = this.validator.validateNumber(this.invoiceAmountGrossInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.totalDiscountInputError = this.validator.validateNumber(this.totalDiscountInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.vatRateInputError = this.validator.validateNumber(this.vatRateInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.vatAmountInputError = this.validator.validateNumber(this.vatAmountInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.nontaxableAmountInputError = this.validator.validateNumber(this.nontaxableAmountInput, Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, false, false);
    this.adminNotesInputError = this.validator.validateLength(this.adminNotesInput, 2, 1000, false)

    if (this.forPeriodDate) {
      const formatted = this.dateConversion.isoToFormattedDate(this.forPeriodDate.toISOString());
      this.forPeriodInputError = this.validator.validateDate(formatted);
    } else {
      this.forPeriodInputError = this.transloco.translate('invoice.errors.invalid_date');
    }

    return !(
      this.invoiceNumberInputError ||
      this.totalConsumptionInputError ||
      this.invoiceAmountActualInputError ||
      this.invoiceAmountGrossInputError ||
      this.totalDiscountInputError ||
      this.forPeriodInputError ||
      this.vatRateInputError ||
      this.vatAmountInputError ||
      this.nontaxableAmountInputError ||
      this.adminNotesInputError
    );
  }

  async saveInvoice(): Promise<void> {
    this.saveClicked = true;

    if (!this.validateInputs()) {
      this.saveClicked = false;
      return;
    }

    this.savingInvoice = true;

    try {
      const response = await lastValueFrom(this.invoiceService.updateFullGasInvoice(this.getGasInvoiceDataFromInputs()))
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 4000, false);
      this.successful = false;
      this.saveClicked = false;
      this.savingInvoice = false;
      return;
    }

    // Save Additiona Fields
    await this.saveAdditionalNoteFields(this.invoice?.id || '');

    // Save File Changes in Log
    if (this.invoice) {
      await this.logInvoiceChanges(this.invoice, this.getGasInvoiceFromInputs());
    }

    this.successful = true;
    this.savingInvoice = false;
    this.cancelEditInvoiceData()
    this.reloadCallbackFunction();
  }

  getFieldsToIgnore(oldInvoice: GasInvoice, newInvoice: GasInvoice) {
    const ignoreFields = ['calc_data', 'admin_notes', 'company', 'vat_id', 'id'];

    // Special check to avoid false difference
    const normalize = (v?: string | null) => {
      if (v === null || v === undefined) return '';
      const t = String(v).trim();
      return t === 'None' ? '' : t;
    };
    const compare = (a?: string | null, b?: string | null) =>
      normalize(a).toLowerCase() === normalize(b).toLowerCase();

    // Flags
    let allConsumptionClassesEqual = true;
    let allSupplierNameEqual = true;
    let allSupplierVatIdEqual = true;
    let allSupplierContactNameEqual = true;
    let allSupplierContactNumberEqual = true;
    let allSupplierEmailEqual = true;

    // Go over pdrs
    if (oldInvoice.pdrs?.length === newInvoice.pdrs?.length) {
      for (let i = 0; i < oldInvoice.pdrs.length; i++) {
        const oldPod = oldInvoice.pdrs[i];
        const newPod = newInvoice.pdrs[i];

        // supplier fields
        if (!compare(oldPod?.supplier?.name, newPod?.supplier?.name)) {
          allSupplierNameEqual = false;
        }
        if (!compare(oldPod?.supplier?.vat_id, newPod?.supplier?.vat_id)) {
          allSupplierVatIdEqual = false;
        }
        if (!compare(oldPod?.supplier?.contact_name, newPod?.supplier?.contact_name)) {
          allSupplierContactNameEqual = false;
        }
        if (!compare(oldPod?.supplier?.contact_number, newPod?.supplier?.contact_number)) {
          allSupplierContactNumberEqual = false;
        }
        if (!compare(oldPod?.supplier?.email, newPod?.supplier?.email)) {
          allSupplierEmailEqual = false;
        }

        if (
          !allConsumptionClassesEqual &&
          !allSupplierNameEqual &&
          !allSupplierVatIdEqual &&
          !allSupplierContactNameEqual &&
          !allSupplierContactNumberEqual &&
          !allSupplierEmailEqual
        ) break;
      }
    } else {
      allConsumptionClassesEqual = false;
      allSupplierNameEqual = false;
      allSupplierVatIdEqual = false;
      allSupplierContactNameEqual = false;
      allSupplierContactNumberEqual = false;
      allSupplierEmailEqual = false;
    }

    // Add ignore fields
    if (allSupplierNameEqual) ignoreFields.push('supplier.name');
    if (allSupplierVatIdEqual) ignoreFields.push('supplier.vat_id');
    if (allSupplierContactNameEqual) ignoreFields.push('supplier.contact_name');
    if (allSupplierContactNumberEqual) ignoreFields.push('supplier.contact_number');
    if (allSupplierEmailEqual) ignoreFields.push('supplier.email');

    return ignoreFields;
  }

  async logInvoiceChanges(oldInvoice: GasInvoice, newInvoice: GasInvoice) {
    const ignoreFields = this.getFieldsToIgnore(oldInvoice, newInvoice);
    const difference = this.utilsService.getObjectDifferences(oldInvoice, newInvoice, ignoreFields)

    if (difference == undefined) {
      return;
    }

    const message = `Admin ${this.userData.getUser()?.first_name} ${this.userData.getUser()?.last_name} (${this.userData.getUser()?.email}) saved new changes in invoice.`;
    const adminChangesLogData = this.utilsService.getAdminChangesLogData(difference, message, this.exprByField);

    // Save log
    try {
      const response = await lastValueFrom(this.invoiceService.sendFileChangesLog(oldInvoice.file.id, adminChangesLogData))
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 4000, false);
    }
  }

  async saveAdditionalNoteFields(invoiceId: string) {
    var newInvoice = null;
    try {
      newInvoice = await lastValueFrom(this.invoiceService.getGasInvoiceById(invoiceId));
    } catch (error) {
      return;
    }

    if (newInvoice?.pdrs) {
      for (let i = 0; i < newInvoice.pdrs.length; i++) {
        const pdr = newInvoice.pdrs[i];
        const additionalNotes = pdr.additional_note_fields

        try {
          const additionalFields = this.getAdditionalNoteFieldsFromInputs(i, additionalNotes);
          await lastValueFrom(this.invoiceService.saveAdditionalNoteFieldsGas(pdr.id || '', additionalFields));
        }
        catch (error) {
          // pass
        }
      }
    }
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toast.showToast('shared.success', 'admin.invite_copied', 'success', 2000, true);
    }).catch(err => {
    });
  }

  copyJson() {
    var invoice = this.getGasInvoiceDataFromInputs();
    invoice.id = this.invoice?.file.id ?? '';
    const json = JSON.stringify(invoice, null, 2);
    this.copyText(json);
  }

  downloadJson() {
    var invoice = this.getGasInvoiceDataFromInputs();
    invoice.id = this.invoice?.file.id ?? '';
    const json = JSON.stringify(invoice, null, 2);

    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;

    const downloadedFileName = `${this.invoice?.file?.filename?.replace(/\.[^.]+$/, '')}.json` || `gas_invoice-${new Date().toISOString()}.json`;
    a.download = downloadedFileName;

    a.click();

    URL.revokeObjectURL(url);
  }

  checkMandatoryVariableEmptyStatus(variable: any, showOkStatus: boolean = false): InvoiceVariableStatus | undefined {
    if (variable === null || variable === undefined || variable === '') {
      this.mandatoryDataMissing = true;
      return InvoiceVariableStatus.MANDATORY_FIELD_MISSING;
    }

    if (!showOkStatus) {
      return undefined;
    }

    return InvoiceVariableStatus.OK;
  }

  checkVariableEmptyStatus(variable: any, showOkStatus: boolean = false): InvoiceVariableStatus | undefined {
    if (variable === null || variable === undefined || variable === '') {
      return InvoiceVariableStatus.OPTIONAL_FIELD_EMPTY;
    }

    if (!showOkStatus) {
      return undefined;
    }

    return InvoiceVariableStatus.OK;
  }

  getInvoiceDeltaStatus(calculationNumber: number | null | undefined, extractionNumber: number | null | undefined, thresholdPercent = 5, warnExtractionEmpty = true): InvoiceVariableStatus | undefined {
    if (warnExtractionEmpty && (extractionNumber === null || extractionNumber === undefined)) {
      return InvoiceVariableStatus.WARNING;
    }

    const calc = calculationNumber != null ? Math.round(calculationNumber * 100) / 100 : 0;
    const ext = extractionNumber != null ? Math.round(extractionNumber * 100) / 100 : 0;
    const delta = ext - calc;

    if (delta === 0) {
      return undefined;
    }

    // diff
    const relativeDiff = calc !== 0 ? Math.abs(delta) / Math.abs(calc) * 100 : Math.abs(delta) * 100; // fallback if calc=0

    if (relativeDiff < thresholdPercent) {
      return InvoiceVariableStatus.WARNING;
    }

    return InvoiceVariableStatus.ERROR;
  }

  loadFileSummary() {
    const fileId = this.invoice?.file.id ?? '';
    this.loadingFileSummary = true;
    this.fileDetailsResponse = null;

    this.filesService.getFileFullData(fileId).subscribe({
      next: (response) => {
        this.fileDetailsResponse = response;
        this.loadingFileSummary = false;
      },
      error: () => {
        this.toast.showToast("shared.error", "admin.not_found", "error", 3000, true);
        this.loadingFileSummary = false;
      }
    });
  }

  onFileSummaryOpen(isOpen: boolean) {
    if (isOpen) {
      this.loadFileSummary();
    }
  }

  editInvoiceData() {
    this.isEditingInvoiceData = true;
  }

  cancelEditInvoiceData() {
    this.isEditingInvoiceData = false;
    this.resetInvoiceData();
  }

  saveEditInvoiceData() {
    // Temp reset mandatory data missing
    this.mandatoryDataMissing = false;

    this.saveInvoice();
  }

  safeValue(value: any, format: string = '1.2-2'): any {
    if (value !== null && value !== undefined) {
      return this.decimalPipe.transform(value, format);
    }
    return '';
  }

  safeStringValue(value: any): any {
    if (value !== null && value !== undefined) {
      return value;
    }
    return '';
  }

  getPriceType(selectedPriceTypeDropdown: number | undefined) {
    if (selectedPriceTypeDropdown === undefined) {
      return null;
    }
    return this.priceTypeDropdownOptions[selectedPriceTypeDropdown].toUpperCase() as PriceType;
  }

  handleMissingDataClick() {
    if (this.invoiceDataDropdown == undefined) { return; }

    if (!this.invoiceDataDropdown.isOpen) {
      this.invoiceDataDropdown.toggle();
    }

    this.editInvoiceData();
    this.invoiceDataDropdownEl?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  isAnyMandatoryVariableMissing(): boolean {
    return this.mandatoryDataMissing;
  }

  onExprChange(fieldKey: string, index: number, expr: string | null) {
    const id = `${fieldKey}#${index}`;

    if (expr && expr.trim() !== '=' && expr.trim() !== '') {
      this.exprByField[id] = expr.trim();
    } else {
      delete this.exprByField[id];
    }
  }

  onPdrSectionOpenedChange(index: number, isOpen: boolean) {
    if (isOpen) {
      this.openedPdrSectionIndexes.add(index);
    } else {
      this.openedPdrSectionIndexes.delete(index);
    }
  }

  restoreOpenedPdrSections() {
    if (!this.pdrSectionsDropdown) { return; }

    const sections = this.pdrSectionsDropdown.toArray();
    this.openedPdrSectionIndexes.forEach(i => {
      const section = sections[i];
      if (section && !section.isOpen) {
        section.toggle();
      }
    });
  }
}
